import Formatter from './Formatter';
// @ts-ignore
import en from "./en_US.json";
// @ts-ignore
import ru from "./ru_RU.json";
const DICTIONARIES = {
    'en-US': en,
    'ru-RU': ru,
};
const REGULARS = {
    main: new RegExp(/\{\s*([^,}]+)\s*(?:,\s*([^,}]+)\s*)?(,(?:\s*[\w=]+\{(?:\\\{|\\\}|[^}])+\})*)?\}/ug),
    options: new RegExp(/(?:\s*([\w=]+)\{((?:\\\{|\\\}|[^}])+)\})+?/ug),
    escape: new RegExp(/\\([{}])/ug),
};
export default class Messages {
    static getDictionary() {
        return DICTIONARIES[Messages.lang];
    }
    static registerLanguageVersion(version) {
        Messages.lang = version;
    }
    /**
     * @param {String} category
     * @param {String} message
     * @param {Object?} params
     * @return {String}
     */
    static t(category, message, params) {
        const dictionary = Messages.getDictionary();
        if (!dictionary.hasOwnProperty(category)) {
            return Messages.replace(message, params);
        }
        const dictCategory = dictionary[category];
        if (!dictCategory.hasOwnProperty(message)) {
            return Messages.replace(message, params);
        }
        return Messages.replace(dictCategory[message], params);
    }
    /**
     * @param {String} message
     * @param params
     * @return {String}
     */
    static replace(message, params) {
        if (!params || !params.hasOwnProperty) {
            return message;
        }
        return message.replace(REGULARS.main, function (match, name, type, options) {
            if (!params.hasOwnProperty(name)) {
                return match;
            }
            switch (type) {
                case 'number':
                    return Formatter.asNumber(params[name]);
                case 'currency':
                    return Formatter.asCurrency(params[name]);
                case 'percent':
                    return Formatter.asPercent(params[name]);
                case 'date':
                    return Formatter.asDate(params[name]);
                case 'time':
                    return Formatter.asTime(params[name]);
                case 'dateTime':
                    return Formatter.asDateTime(params[name]);
                case 'plural':
                    let pluralOptions = Messages.parseOptions(options);
                    return Formatter.asPlural(params[name], pluralOptions);
                default:
                    return params[name];
            }
        });
    }
    /**
     * @property {Formatter} formatter
     */
    static get formatter() {
        return Formatter;
    }
    static parseOptions(input) {
        let options = {};
        input.replace(REGULARS.options, function (match, name, value) {
            options[name] = value.replace(REGULARS.escape, function (match, value) {
                return value;
            });
        });
        return options;
    }
}
Messages.lang = 'en-US';
